import React from 'react'
import { message, Form, Checkbox, Radio, Input, Button, Modal, List, Row, Col } from 'antd'
import { krStrLen } from 'libs/utils';
import { withContext } from 'libs/context';
import KrmsUploadImage from 'components/KrmsUploadImage';
import './authenticationForm.less';
import http from 'libs/http';
import { debounce ,get} from 'lodash';

const FormItem = Form.Item;
const formSpan = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
  style: { width: '100%', marginBottom: 10 }
}
let protocol = window.location.protocol,host = window.location.host;
let url = `${protocol}//${host}`;
class AuthenticationForm extends React.Component {

  constructor(props){
    super(props)
    this.searchCompanyByName = debounce(this.searchCompanyByName, 500);
    this.state = {
      visible: props.visible,
      type: 1,
      checked: false,
      aHref: url + '/home/user/agreement',
      companyList: [], // 企业名称列表 - 天眼查返回
      loading: false,
      showSearchedCompany: false,
      searchingCompany: false,
      isMcn:null
    }
  }
  editInit =() => {
    http.json('/sys/user/certify/modInit')
    .then(res => {
      this.setState({...res, res})
      this.props.form.setFieldsValue({
        ...res,
        businessIdCardFileFront: res.businessIdCardFileFrontUrl,
        businessIdCardFileBack: res.businessIdCardFileBackUrl,
        idCardFileFront: res.idCardFileFrontUrl,
        idCardFileBack: res.idCardFileBackUrl,
      })
    })
  }
  componentDidMount() {
    if (this.props.isEdit) this.editInit()
  }
  //提交
  submitData =() => {
    const { type, checked, loading } = this.state
    if (loading) return;
    this.props.form.validateFieldsAndScroll((err, items) => {
      if(!err) {
        if (!checked) return message.warn('请阅读并同意36氪认证协议!');
        Modal.confirm({
          title: '认证',
          content: '是否确认提交认证？',
          onOk: ()=> {
            this.setState({
              loading: true
            })
            let params,url
            let toUrl = `/home/user/authentication`

            if (this.props.isEdit) url = type === 1 ? '/sys/user/certify/personal/mod':'/sys/user/certify/enterprise/mod'
            else url = type === 1 ? '/sys/user/certify/personal/add':'/sys/user/certify/enterprise/add'
            if (type === 1) {
              let idCardFileFront = items.idCardFileFront.fileKey ? items.idCardFileFront.fileKey : items.idCardFileFront.split('param.fileKey=') ? items.idCardFileFront.split('param.fileKey=')[1] : '';
              let idCardFileBack = items.idCardFileBack.fileKey ? items.idCardFileBack.fileKey : items.idCardFileBack.split('param.fileKey=') ? items.idCardFileBack.split('param.fileKey=')[1] : '';

              params= {
              certifyNick: items.certifyNick,
              idCardName: items.idCardName,
              idCardNo: items.idCardNo,
              idCardFileFront,
              idCardFileBack,
            }}
            if (type === 2) {
              let businessIdCardFileFront = items.businessIdCardFileFront.fileKey ? items.businessIdCardFileFront.fileKey : items.businessIdCardFileFront.split('param.fileKey=') ? items.businessIdCardFileFront.split('param.fileKey=')[1] : '';
              let businessIdCardFileBack = items.businessIdCardFileBack.fileKey ? items.businessIdCardFileBack.fileKey : items.businessIdCardFileBack.split('param.fileKey=') ? items.businessIdCardFileBack.split('param.fileKey=')[1] : ''

              let path = items.businessLicense.path?items.businessLicense.path:items.businessLicense
              let pathArr = path.split('com')
              if (pathArr.length > 1) path = pathArr[1]
              params = {
                businessLicense: path,
                certifyNick: items.certifyNick,
                businessName: items.businessName,
                taxpayerCode: items.taxpayerCode,
                isMcn: items.isMcn,
                mcn: get(items,'mcn',''),
                businessIdCardName: items.businessIdCardName,
                businessIdCardNo: items.businessIdCardNo,
                businessIdCardFileFront,
                businessIdCardFileBack,
              }
            }
            http.json(url, params)
            .then(() => {
              this.setState({
                loading: false
              })
              message.success('提交成功');
              this.props.isShowForm()
              window.location.replace(toUrl);
            });
          },
          onCancel: ()=> {
            return
          },
        })
      }
    });
  }

  //按照企业名关键字搜企业
  searchCompanyByName = (name) => {
    if (!name) return;
    const { form } = this.props;
    const { setFieldsValue } = form;
    this.setState({ searchingCompany: true });
    setFieldsValue({taxpayerCode: ''});
    http.json('/tool/company/search', { keyword: name })
    .then(res => {
      this.setState({
        searchingCompany: false,
        companyList: res.companyList || []
      });
    }).catch(() => this.setState({searchingCompany: false}));
  }

  selectCompany = item => {
    const { form } = this.props;
    const { setFieldsValue } = form;
    setFieldsValue({
      businessName: item.name,
      taxpayerCode: item.creditCode
    });
  }

  render() {
    const {ucUserId, nick, form, visible, cancel} = this.props
    const { getFieldDecorator } = form
    const { type, aHref, companyList, showSearchedCompany, searchingCompany } = this.state
    const reg = /^[1-9][0-9]{5}(19[0-9]{2}|200[0-9]|20[1-4][0-9])(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[0-9]{3}[0-9xX]$/i
    const nameReg = /^[\u2E80-\u9FFF]+$/
    return (
      <Modal width="590px" visible={visible} footer={[cancel, <Button key="submit" type="primary" onClick={this.submitData}>提交认证</Button> ]} closable={false} title="创作者认证" className="krms-authenticationForm">
        <Form>
            <FormItem label="ID" {...formSpan}>
              <span>{ucUserId}</span>
            </FormItem>
            <FormItem label="昵称" {...formSpan}>
              <span>{nick}</span>
            </FormItem>
            <FormItem label="类型" {...formSpan}>
              <Radio.Group onChange={e => {
                this.setState({
                  checked: false,
                  type: e.target.value,
                });
              }} value={type}>
                <Radio value={1}>个人</Radio>
                <Radio value={2}>企业</Radio>
              </Radio.Group>
            </FormItem>
            {type === 2&&
            <React.Fragment>
              <FormItem label="营业执照照片" {...formSpan}>
                {getFieldDecorator('businessLicense', {
                    rules: [
                      { required: true, message: `请上传营业执照照片` },
                    ]
                  })(
                    <KrmsUploadImage
                      size={5120}
                      allowClear={false}
                      accept={'.jpg, .png, .jpeg'}
                    />
                  )}
                  <ol>
                    <li className="imgRule">上传最新版三证合一营业执照清晰正面照，仅支持大陆工商颁布的营业执照，请确认证件在有效期内</li>
                    <li className="imgRule">大小不超过5M，支持jpg、png、jpeg</li>
                  </ol>
              </FormItem>
              <FormItem label="认证名称" {...formSpan} extra="当前媒体账号的认证名称">
                {getFieldDecorator('certifyNick', {
                  rules: [
                    { required: true, message: '请填写认证名称' },
                    { validator: (rule, value, callback) => {
                      if (krStrLen(value) > 20) {
                        callback('认证名称至多20字');
                      } else {
                        callback();
                      }
                    }}
                  ]
                })(
                  <Input placeholder="请填写认证名称" />
                )}
              </FormItem>
              <FormItem label="企业名称" {...formSpan}>
                {getFieldDecorator('businessName', {
                  rules: [
                    { required: true, message: '请填写企业名称' },
                    { validator: (rule, value, callback) => {
                      if (krStrLen(value) > 30) {
                        callback('企业名称至多30个字');
                      } else {
                        callback();
                      }
                    }}
                  ],
                  onChange:e => this.searchCompanyByName(e.target.value),
                })(
                  <Input
                    onBlur={debounce(() => this.setState({ showSearchedCompany: false }),300)}
                    onFocus={() => this.setState({ showSearchedCompany: true })}
                    placeholder="请填写企业名称" />
                )}
              </FormItem>
              <div className="ant-row ant-form-item" style={{marginBottom: 0}}>
                <div className="ant-col ant-col-18 ant-col-offset-6 company-content">
                  <div className={`list-content ${showSearchedCompany ? 'visible' : ''}`}>
                    <List
                      locale={{ emptyText: '暂无相关结果' }}
                      itemLayout="horizontal"
                      dataSource={companyList}
                      loading={searchingCompany}
                      renderItem={item => (
                        <List.Item
                          onClick={() => this.selectCompany(item)}
                        >
                          {item.name}
                        </List.Item>
                      )}
                    />
                  </div>
                </div>
              </div>
              <FormItem label="纳税人识别号" {...formSpan}>
                {getFieldDecorator('taxpayerCode', {
                  rules: [
                    {pattern: /^[A-Za-z0-9]+$/, message: '请填写正确的纳税人识别号'},
                    { required: true, message: '请填写纳税人识别号' },
                    { validator: (rule, value, callback) => {
                      if (krStrLen(value) > 20) {
                        callback('纳税人识别号至多20字');
                      } else {
                        callback();
                      }
                    }}
                  ]
                })(
                  <Input placeholder="请填写纳税人识别号" />
                )}
              </FormItem>
              <FormItem label="授权人姓名" {...formSpan} extra="当前账号授权使用人的姓名">
                {getFieldDecorator('businessIdCardName', {
                  rules: [
                    { required: true, message: '请填写授权人姓名' },
                    { validator: (rule, value, callback) => {
                      if (krStrLen(value) > 20) {
                        callback('授权人姓名至多20个字');
                      } else {
                        callback();
                      }
                    }}
                  ]
                })(
                  <Input placeholder="请填写授权人姓名" />
                )}
              </FormItem>
              <FormItem label="身份证照片-正面" {...formSpan}>
              {getFieldDecorator('businessIdCardFileFront', {
                    rules: [
                      { required: true, message: `请上传身份证照片` },
                    ]
                  })(
                    <KrmsUploadImage
                      size={5120}
                      allowClear={false}
                      accept={'.jpg, .png, .jpeg'}
                      api="tool/private/upload"
                    />
                  )}
              </FormItem>
              <FormItem {...formSpan} label="身份证照片-反面">
              {getFieldDecorator('businessIdCardFileBack', {
                    rules: [
                      { required: true, message: `请上传身份证照片` },
                    ]
                  })(
                    <KrmsUploadImage
                      size={5120}
                      allowClear={false}
                      accept={'.jpg, .png, .jpeg'}
                      api="tool/private/upload"
                    />
                  )}
              </FormItem>

              <FormItem label="授权人身份证号" {...formSpan} extra="当前账号授权使用人的身份证号">
                {getFieldDecorator('businessIdCardNo', {
                  rules: [
                    {pattern: reg, message: '请填写正确的授权人身份证号'},
                    { required: true, message: '请填写授权人身份证号' },
                    { validator: (rule, value, callback) => {
                      if (krStrLen(value) > 18) {
                        callback('身份证号至多18位');
                      } else {
                        callback();
                      }
                    }}
                  ]
                })(
                  <Input placeholder="请填写身份证号" />
                )}
              </FormItem>
              <FormItem label="是否为MCN" {...formSpan}>
                {getFieldDecorator('isMcn', {
                    rules: [
                      { required: true, message: '请选择是否为MCN' },
                    ]
                  })(
                    <Radio.Group onChange={e => {
                      this.setState({
                        isMcn: e.target.value,
                      });
                    }} value={type}>
                      <Radio value={1}>是</Radio>
                      <Radio value={0}>否</Radio>
                    </Radio.Group>
                  )}
              </FormItem>
              {/* MCN名称 */}
              {this.state.isMcn === 1 ? (
                <Form.Item label="MCN名称："  {...formSpan}>
                  {getFieldDecorator('mcn', {
                    rules: [
                      { required: true, message: '请填写MCN名称' },
                      { validator: (rule, value, callback) => {
                        if (krStrLen(value) > 30) {
                          callback('MCN名称至多30个字');
                        } else {
                          callback();
                        }
                      }}
                    ]
                  })(
                    <Input
                      onChange={this.checkSubmitStatus}
                      placeholder="请填写已申请的MCN名称"
                    ></Input>
                  )}
                </Form.Item>
              ) : null}


            </React.Fragment>
            }

            {type === 1&&
            <React.Fragment>
              <FormItem label="认证名称" {...formSpan} extra="当前媒体账号的认证名称">
                {getFieldDecorator('certifyNick', {
                  rules: [
                    { required: true, message: '请填写认证名称' },
                    { validator: (rule, value, callback) => {
                      if (krStrLen(value) > 20) {
                        callback('认证名称至多20字');
                      } else {
                        callback();
                      }
                    }}
                  ]
                })(
                  <Input placeholder="请填写认证名称" />
                )}
              </FormItem>
              <FormItem label="姓名" {...formSpan}>
                {getFieldDecorator('idCardName', {
                  rules: [
                    { pattern: nameReg, message: '请填写正确的姓名' },
                    { required: true, message: '请填写姓名' },
                    { validator: (rule, value, callback) => {
                      if (krStrLen(value) > 20) {
                        callback('姓名至多20字');
                      } else {
                        callback();
                      }
                    }}
                  ]
                })(
                  <Input placeholder="请填写姓名" />
                )}
              </FormItem>
              <FormItem label="身份证照片-正面" {...formSpan}>
              {getFieldDecorator('idCardFileFront', {
                    rules: [
                      { required: true, message: `请上传身份证照片` },
                    ]
                  })(
                    <KrmsUploadImage
                      size={5120}
                      allowClear={false}
                      accept={'.jpg, .png, .jpeg'}
                      api="tool/private/upload"
                    />
                  )}
              </FormItem>
              <FormItem label="身份证照片-反面" {...formSpan}>
              {getFieldDecorator('idCardFileBack', {
                    rules: [
                      { required: true, message: `请上传身份证照片` },
                    ]
                  })(
                    <KrmsUploadImage
                      size={5120}
                      allowClear={false}
                      accept={'.jpg, .png, .jpeg'}
                      api="tool/private/upload"
                    />
                  )}
              </FormItem>
              <FormItem label="身份证号" {...formSpan}>
                {getFieldDecorator('idCardNo', {
                  rules: [
                    {pattern: reg, message: '请填写正确的身份证号'},
                    { required: true, message: '请填写身份证号' },
                    { validator: (rule, value, callback) => {
                      if (krStrLen(value) > 18) {
                        callback('身份证号至多18位');
                      } else {
                        callback();
                      }
                    }}
                  ]
                })(
                  <Input placeholder="请填写身份证号" />
                )}
              </FormItem>
            </React.Fragment>
            }
            <div className="agreement">
              <Checkbox onChange={(e)=>{this.setState({'checked': e.target.checked})}} checked={this.state.checked}>我已阅读并同意</Checkbox>
              <a href={aHref}  target="_blank" rel="noopener noreferrer">《36氪认证协议》</a>
              <p><span>*</span>信息仅用于身份认证，我们将严格保护您的数据和隐私安全</p>
            </div>
          </Form>
      </Modal>
    )
  }

}
export default Form.create()(withContext('authority')(AuthenticationForm));